import React, { useMemo } from "react";
import { ColorSystemProps, GOI_WEB_URL } from "../../../constants";
import { Box, Stack } from "@mui/material";
import { FullWidthButton } from "../../common/Buttons/FullWidthButton";
import { ColorIcon } from "../../common/Icons";
import { ClickEventType, ParlorDetailProps } from "../../../types";
import { GoiPriceDescription } from "../GoiPriceDescription";

export function BTypeCTA({
  mainColor,
  sidoName,
  sigunguName,
  event,
  defaultParlor,
}: {
  mainColor: ColorSystemProps;
  sidoName?: string;
  sigunguName?: string;
  event?: ClickEventType;
  defaultParlor?: ParlorDetailProps;
}) {
  const id = defaultParlor?.id;

  const href = id
    ? `${GOI_WEB_URL}/match/parlor-requests/${id}?utm_source=dogsound`
    : `${GOI_WEB_URL}/match/request/?utm_source=dogsound`;

  const text = useMemo(() => {
    if (id) {
      return (
        <>
          고이에서 장례식장의 빈소, 음식 가격 등
          <br />
          전체 장례식장 비용을 확인해보세요.
          <br />
          (e하늘 장사정보시스템 기반으로 안내)
          <br />
          <br />
          비용 줄일 수 있는 방법까지 상세히 안내해드려요.
        </>
      );
    } else {
      return (
        <>
          고이에서 전체 장례 비용(장지, 장례 용품 포함)
          <br />
          상세 장례 비용을 더 알아 보세요.
          <br />
          (e하늘 장사정보시스템 기반으로 안내)
          <br />
          <br />
          비용 줄일 수 있는 방법까지 상세히 안내해드려요.
        </>
      );
    }
  }, [id]);

  return (
    <Stack gap="16px" padding="0 20px 20px">
      <Box className="subtitle_16_b" textAlign="center">
        {text}
      </Box>

      <FullWidthButton
        backgroundColor={mainColor.c400}
        text="장례 비용 확인하기"
        href={href}
        event={event}
      />
      <GoiPriceDescription padding="10px 0px" />

      <Stack flexDirection="row" gap="6px" alignItems="center">
        <ColorIcon name="icon-check-fill-mono" size={14} color="" />
        <Box className="caption_12_m">{`이 지역 기반으로 알아보기`}</Box>
      </Stack>
    </Stack>
  );
}
